import React, {useEffect, useState} from 'react';
import {
    List,
    Section,
    Input,
    Button, Cell, Switch, Placeholder, Spinner
} from '@telegram-apps/telegram-ui';
import InfoFooter from "../component/InfoFooter";
import {
    get_all_area_api,
    release_user_api,
    remove_user_api,
    reset_user_modified_time_api,
    reset_user_score_api,
    reset_user_unlock_api, set_area_enable_api,
    set_user_by_id_api
} from "../api/AdminAPI";
import toast from "react-hot-toast";
import WebApp from "@twa-dev/sdk";
import {login_api} from "../api/UserAPI";
import {ImCrying} from "react-icons/im";


function AreaManagement() {
    const [areaList, setAreaList] = useState([] as ResponseAreaNodeEntity[]);
    useEffect(() => {
        get_all_area_api().then(res => {
            setAreaList(res.data.data)
        })
    }, [])

    function onSwitchChange(areaNodeEntity: ResponseAreaNodeEntity, checked: boolean) {
        let enable = checked ? 1 : 0
        set_area_enable_api(areaNodeEntity.area_id, enable).then(res => {
            toast.success(res.data.message);
            areaNodeEntity.enable = enable
            let areaListCopy = [] as ResponseAreaNodeEntity[]
            Object.assign(areaListCopy, areaList)
            setAreaList(areaListCopy)
        })
    }

    return (
        <List>
            <Section
                header="地区列表"
            >
                {
                    areaList.length === 0 &&
                    <Placeholder description="正在加载所有列表...">
                        <Spinner size="s"/>
                    </Placeholder>
                }
                {
                    areaList.length !== 0 &&
                    areaList.map(item =>
                        <Cell after={<Switch checked={item.enable == 1}
                                             onChange={event => onSwitchChange(item, event.target.checked)}/>}
                              subhead={"上级节点：" + item.parent_id}
                        >{item.area_id + "-" + item.name}</Cell>
                    )
                }
            </Section>
            <InfoFooter/>
        </List>
    );
}

export default AreaManagement;
